export enum EMPLOYEE {
  WRAPPER = "employeeWrapper",
  VERIFIED_PROFILE_BADGE = "employeeVerifiedProfileBadge",
  BUTTON = "employeeSelectButton",
}
